import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import Y, { popoverBaseProps as L } from "../../popover/src/Popover.js";
import { dropdownInjectionKey as Z } from "./context.js";
import ee from "./DropdownMenu.js";
import oe from "./styles/index.cssr.js";
import te from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import { createTreeMate as ne } from "../../../../../../treemate@0.3.11/node_modules/treemate/es/create.js";
import re from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import ie from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-keyboard.js";
import de from "../../_mixins/use-config.js";
import B from "../../_mixins/use-theme.js";
import le from "../styles/light.js";
import { call as N } from "../../_utils/vue/call.js";
import { createKey as p } from "../../_utils/cssr/index.js";
import { useThemeClass as ae } from "../../_mixins/use-css-vars-class.js";
import { keep as se } from "../../_utils/vue/keep.js";
import { createRefSetter as ce } from "../../_utils/vue/create-ref-setter.js";
import { defineComponent as ue, computed as h, provide as fe, watch as pe, h as z, mergeProps as he } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as I, toRef as a } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const ve = {
  animated: {
    type: Boolean,
    default: !0
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  size: {
    type: String,
    default: "medium"
  },
  inverted: Boolean,
  placement: {
    type: String,
    default: "bottom"
  },
  onSelect: [Function, Array],
  options: {
    type: Array,
    default: () => []
  },
  menuProps: Function,
  showArrow: Boolean,
  renderLabel: Function,
  renderIcon: Function,
  renderOption: Function,
  nodeProps: Function,
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  // for menu, not documented
  value: [String, Number]
}, me = Object.keys(L), ge = Object.assign(Object.assign(Object.assign({}, L), ve), B.props), De = ue({
  name: "Dropdown",
  inheritAttrs: !1,
  props: ge,
  setup(t) {
    const w = I(!1), c = te(a(t, "show"), w), d = h(() => {
      const {
        keyField: e,
        childrenField: i
      } = t;
      return ne(t.options, {
        getKey(n) {
          return n[e];
        },
        getDisabled(n) {
          return n.disabled === !0;
        },
        getIgnored(n) {
          return n.type === "divider" || n.type === "render";
        },
        getChildren(n) {
          return n[i];
        }
      });
    }), u = h(() => d.value.treeNodes), v = I(null), m = I(null), y = I(null), f = h(() => {
      var e, i, n;
      return (n = (i = (e = v.value) !== null && e !== void 0 ? e : m.value) !== null && i !== void 0 ? i : y.value) !== null && n !== void 0 ? n : null;
    }), b = h(() => d.value.getPath(f.value).keyPath), x = h(() => d.value.getPath(t.value).keyPath), K = re(() => t.keyboard && c.value);
    ie({
      keydown: {
        ArrowUp: {
          prevent: !0,
          handler: W
        },
        ArrowRight: {
          prevent: !0,
          handler: U
        },
        ArrowDown: {
          prevent: !0,
          handler: _
        },
        ArrowLeft: {
          prevent: !0,
          handler: H
        },
        Enter: {
          prevent: !0,
          handler: j
        },
        Escape: D
      }
    }, K);
    const {
      mergedClsPrefixRef: P,
      inlineThemeDisabled: C
    } = de(t), A = B("Dropdown", "-dropdown", oe, le, t, P);
    fe(Z, {
      labelFieldRef: a(t, "labelField"),
      childrenFieldRef: a(t, "childrenField"),
      renderLabelRef: a(t, "renderLabel"),
      renderIconRef: a(t, "renderIcon"),
      hoverKeyRef: v,
      keyboardKeyRef: m,
      lastToggledSubmenuKeyRef: y,
      pendingKeyPathRef: b,
      activeKeyPathRef: x,
      animatedRef: a(t, "animated"),
      mergedShowRef: c,
      nodePropsRef: a(t, "nodeProps"),
      renderOptionRef: a(t, "renderOption"),
      menuPropsRef: a(t, "menuProps"),
      doSelect: k,
      doUpdateShow: S
    }), pe(c, (e) => {
      !t.animated && !e && T();
    });
    function k(e, i) {
      const {
        onSelect: n
      } = t;
      n && N(n, e, i);
    }
    function S(e) {
      const {
        "onUpdate:show": i,
        onUpdateShow: n
      } = t;
      i && N(i, e), n && N(n, e), w.value = e;
    }
    function T() {
      v.value = null, m.value = null, y.value = null;
    }
    function D() {
      S(!1);
    }
    function H() {
      R("left");
    }
    function U() {
      R("right");
    }
    function W() {
      R("up");
    }
    function _() {
      R("down");
    }
    function j() {
      const e = F();
      e != null && e.isLeaf && c.value && (k(e.key, e.rawNode), S(!1));
    }
    function F() {
      var e;
      const {
        value: i
      } = d, {
        value: n
      } = f;
      return !i || n === null ? null : (e = i.getNode(n)) !== null && e !== void 0 ? e : null;
    }
    function R(e) {
      const {
        value: i
      } = f, {
        value: {
          getFirstAvailableNode: n
        }
      } = d;
      let o = null;
      if (i === null) {
        const l = n();
        l !== null && (o = l.key);
      } else {
        const l = F();
        if (l) {
          let s;
          switch (e) {
            case "down":
              s = l.getNext();
              break;
            case "up":
              s = l.getPrev();
              break;
            case "right":
              s = l.getChild();
              break;
            case "left":
              s = l.getParent();
              break;
          }
          s && (o = s.key);
        }
      }
      o !== null && (v.value = null, m.value = o);
    }
    const O = h(() => {
      const {
        size: e,
        inverted: i
      } = t, {
        common: {
          cubicBezierEaseInOut: n
        },
        self: o
      } = A.value, {
        padding: l,
        dividerColor: s,
        borderRadius: E,
        optionOpacityDisabled: $,
        [p("optionIconSuffixWidth", e)]: M,
        [p("optionSuffixWidth", e)]: V,
        [p("optionIconPrefixWidth", e)]: q,
        [p("optionPrefixWidth", e)]: G,
        [p("fontSize", e)]: J,
        [p("optionHeight", e)]: Q,
        [p("optionIconSize", e)]: X
      } = o, r = {
        "--n-bezier": n,
        "--n-font-size": J,
        "--n-padding": l,
        "--n-border-radius": E,
        "--n-option-height": Q,
        "--n-option-prefix-width": G,
        "--n-option-icon-prefix-width": q,
        "--n-option-suffix-width": V,
        "--n-option-icon-suffix-width": M,
        "--n-option-icon-size": X,
        "--n-divider-color": s,
        "--n-option-opacity-disabled": $
      };
      return i ? (r["--n-color"] = o.colorInverted, r["--n-option-color-hover"] = o.optionColorHoverInverted, r["--n-option-color-active"] = o.optionColorActiveInverted, r["--n-option-text-color"] = o.optionTextColorInverted, r["--n-option-text-color-hover"] = o.optionTextColorHoverInverted, r["--n-option-text-color-active"] = o.optionTextColorActiveInverted, r["--n-option-text-color-child-active"] = o.optionTextColorChildActiveInverted, r["--n-prefix-color"] = o.prefixColorInverted, r["--n-suffix-color"] = o.suffixColorInverted, r["--n-group-header-text-color"] = o.groupHeaderTextColorInverted) : (r["--n-color"] = o.color, r["--n-option-color-hover"] = o.optionColorHover, r["--n-option-color-active"] = o.optionColorActive, r["--n-option-text-color"] = o.optionTextColor, r["--n-option-text-color-hover"] = o.optionTextColorHover, r["--n-option-text-color-active"] = o.optionTextColorActive, r["--n-option-text-color-child-active"] = o.optionTextColorChildActive, r["--n-prefix-color"] = o.prefixColor, r["--n-suffix-color"] = o.suffixColor, r["--n-group-header-text-color"] = o.groupHeaderTextColor), r;
    }), g = C ? ae("dropdown", h(() => `${t.size[0]}${t.inverted ? "i" : ""}`), O, t) : void 0;
    return {
      mergedClsPrefix: P,
      mergedTheme: A,
      // data
      tmNodes: u,
      // show
      mergedShow: c,
      // methods
      handleAfterLeave: () => {
        t.animated && T();
      },
      doUpdateShow: S,
      cssVars: C ? void 0 : O,
      themeClass: g == null ? void 0 : g.themeClass,
      onRender: g == null ? void 0 : g.onRender
    };
  },
  render() {
    const t = (d, u, v, m, y) => {
      var f;
      const {
        mergedClsPrefix: b,
        menuProps: x
      } = this;
      (f = this.onRender) === null || f === void 0 || f.call(this);
      const K = (x == null ? void 0 : x(void 0, this.tmNodes.map((C) => C.rawNode))) || {}, P = {
        ref: ce(u),
        class: [d, `${b}-dropdown`, this.themeClass],
        clsPrefix: b,
        tmNodes: this.tmNodes,
        style: [...v, this.cssVars],
        showArrow: this.showArrow,
        arrowStyle: this.arrowStyle,
        scrollable: this.scrollable,
        onMouseenter: m,
        onMouseleave: y
      };
      return z(ee, he(this.$attrs, P, K));
    }, {
      mergedTheme: w
    } = this, c = {
      show: this.mergedShow,
      theme: w.peers.Popover,
      themeOverrides: w.peerOverrides.Popover,
      internalOnAfterLeave: this.handleAfterLeave,
      internalRenderBody: t,
      onUpdateShow: this.doUpdateShow,
      "onUpdate:show": void 0
    };
    return z(Y, Object.assign({}, se(this.$props, me), c), {
      trigger: () => {
        var d, u;
        return (u = (d = this.$slots).default) === null || u === void 0 ? void 0 : u.call(d);
      }
    });
  }
});
export {
  De as default,
  ge as dropdownProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dropdown/src/Dropdown.js
// module id = 1681
// module chunks = 67